/** The ids that tie a `Tabs` row to the panel it controls. */

/** The id of one tab, for the panel's `aria-labelledby`. */
export function tabId(id: string, tab: string): string {
  return `${id}-${tab}`;
}

/** The id of the panel the tabs control. */
export function tabPanelId(id: string): string {
  return `${id}-panel`;
}
